<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/IWD02U/tc-custom/9781401689629.jpg?1721404537957" alt="This image is the cover for the book Motherless"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Motherless
      </h1>
      <p class="bookDescription body article font2">
        <p><b>A WHISPERING VOICE <i>at the </i>BACK <i>of </i>MY MIND REMINDS ME <i>that </i>I’VE BEEN THIS WAY <i>for </i>SOME TIME.</b></p><p><b>DEAD, THAT IS.</b></p><p>The dead have a very broad view of the living, of actions performed out of sight, of thoughts believed to be private. I would know. Losing both parents is a trial no child should endure, and Marina and Dylan have endured enough. They deserve the one thing I could never give them: a mother’s love.</p><p>A mother’s love, and the truth.</p><p>My children have believed a lie about me for years and years. After all this time I can still feel their hurt in my heart. But the tether holding me to them is frayed from years of neglect . . . and I have to find a way to make my confession before it snaps.</p><p>But when the truth comes out, what other beasts will I unleash?</p><p>“Why do we lie to the children?” someone asked me once.</p><p>“To protect them,” I answered.</p><p>How terrible it is that they need protection from me.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Erin Healy
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Thomas Nelson
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?2f4cbace